// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Perspective_wrapper__6VKNv","glass":"Perspective_glass__QicRq"};